<template>
  <div class="mainpart">
    <!-- 操作盒子 -->
    <div class='operationBox'>
      <!-- 播放/暂停 -->
      <div @click='playBtn' class="playButtCon" id="playButtCon">
        <PauseOutlined v-if="isPlaying" />
        <CaretRightOutlined v-else />
      </div>
      <!-- 音频轨迹 -->
      <div @mousedown='trackDown' @mousemove='trackMove' @mouseup='trackUp' class="audioTrack" ref="audioTrack">
        <!-- 进度百分比 -->
        <div class="audioPercentage" ref='audioPercentage' :style="{ width: accomplishData + unit }">
        </div>
        <div class="player-currentTime">{{ formatTime(currentTime) }}</div>
        <div class="player-totalTime">{{ formatTime(altogetherTimer) }}</div>
      </div>
      <!-- 音频倍速控件 -->
      <a-dropdown placement="top" >
        <span class="sound-speed">{{ audioSpeed }}x</span>
        <template #overlay>
          <a-menu class="speed-menu" :selectedKeys="[audioSpeed]">
            <a-menu-item v-for="item in speedArray" :key="item"  @click="changePlaybackRate(item)">
              {{item}}x
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <!-- reset / time -->
      <div class="sound-right">
        <SoundOutlined class="sound" />
        <input class="sound-range" type="range" min="0" max="1" step="any" value="1" @input="setVolume($event)">
      </div>
    </div>
    <!-- 原生音频文件 -->
    <div class="originalAudio">
      <audio ref='audioEl' :src="source" controls="controls" id="myAudio" @canplaythrough="oncanplaythrough">
        <!-- <source :src="source" type="audio/mpeg"> -->
      </audio>
    </div>
  </div>
</template>

<script>
import { PauseOutlined, CaretRightOutlined, SoundOutlined } from '@ant-design/icons-vue';
let timer
export default {
  name: 'audio-vue',
  components: { PauseOutlined, CaretRightOutlined, SoundOutlined },
  props: {
    source: {
      type: String,
      // default: 'http://music.163.com/song/media/outer/url?id=431795489.mp3'
    }
  },
  data() {
    return {
      speedArray: [3, 2, 1.5, 1.25, 1, 0.75, 0.5],
      // source: 'http://localhost:8081/SomeoneLikeYou.mp3',
      playButtConText: '▶',
      isPlaying: false,
      altogetherTimer: null, //音频总时长
      accomplishData: null, // 当前播放进度比
      countTime: null, // 倒计时时间
      currentTime: 0, // 当前播放时间
      unit: '%', //单位
      showRet: false,
      isTransition: true,
      ismouseDown: false,
      lastMoveVal: 0,
      audioSpeed: 1, // 音频播放速度
    }
  },
  methods: {
     changePlaybackRate(value) {
      this.audioSpeed = value
      this.$refs.audioEl.playbackRate = this.audioSpeed;
    },
    // oncanplaythrough 事件在视频/音频（audio/video）可以正常播放且无需停顿和缓冲时触发
    oncanplaythrough() {
      if (this.$refs.audioEl && this.$refs.audioEl.duration) {
        this.altogetherTimer = Math.round(this.$refs.audioEl.duration) === Infinity ? 0 : Math.round(this.$refs.audioEl.duration)
      } else {
        this.altogetherTimer = 0
      }
    },
    hoverFn() {
      this.showRet = true
    },
    outFn() {
      this.showRet = false
    },
    // 正在播放时音频轨迹的状态
    myAudioPlay(PercentageData) {
      let audioEl = this.$refs.audioEl
      if (!audioEl) return
      
      this.unit = '%'
      this.accomplishData = PercentageData * 100
      if (audioEl?.currentTime == audioEl.duration) {
        this.playButtConText = '▶'
        this.isPlaying = false
        clearInterval(timer)
      }
    },
    playBtn() {
      let audioEl = this.$refs.audioEl
      if (!audioEl) return
      
      if (audioEl.paused) {
        if (audioEl.currentTime == audioEl.duration) {
          this.accomplishData = 0
        }
        audioEl.play()
        clearInterval(timer) // 清除计时器
        this.playButtConText = '■'
        this.isPlaying = true
        timer = setInterval(() => {
          if (!audioEl || !audioEl.duration) {
            clearInterval(timer)
            return
          }
          this.currentTime = Math.round(audioEl.currentTime)
          this.$emit('time', this.currentTime)
          this.myAudioPlay(audioEl.currentTime / audioEl.duration) // 计算播放进度百分比
          this.countTime = this.altogetherTimer - Math.round(audioEl.currentTime)
        }, 10)
      } else {
        audioEl.pause()
        clearInterval(timer) // 清除计时器
        this.playButtConText = '▶'
        this.isPlaying = false
      }
    },
    pause() {
      let audioEl = this.$refs.audioEl
      audioEl.pause()
      this.isPlaying = false
    },
    setPlayTime (currentTime) {
      let audioEl = this.$refs.audioEl
      if (!audioEl || !audioEl.duration) return
      
      audioEl.currentTime = currentTime
      this.currentTime = Math.round(audioEl.currentTime)
      this.myAudioPlay(audioEl.currentTime / audioEl.duration)
      this.countTime = this.altogetherTimer - Math.round(audioEl.currentTime)
      
    },
    retPlay() {
      let audioEl = this.$refs.audioEl
      audioEl.currentTime = 0
      this.accomplishData = 0
      this.countTime = null
      audioEl.pause()
      this.playBtn()
    },
    trackFn(ev) {
      let audioTrack = this.$refs.audioTrack // 音频轨迹
      let audioEl = this.$refs.audioEl
      if (!audioTrack || !audioEl || !audioEl.duration) return
      
      let audioTrackW = audioTrack.offsetWidth // 读取音频轨迹的长度
      this.unit = 'px'
      this.accomplishData = ev.layerX
      let cilckPercentage = ev.layerX / audioTrackW
      audioEl.currentTime = cilckPercentage * audioEl.duration
      this.countTime = this.altogetherTimer - Math.round(audioEl.currentTime)
    },
    // 点击音频轨迹
    trackDown(ev) {
      this.ismouseDown = true
      this.unit = 'px'
      this.accomplishData = ev.layerX
    },
    trackMove(ev) {
      if (this.ismouseDown) {
        this.trackFn(ev)
      }
    },
    trackUp(ev) {
      this.ismouseDown = false
      this.trackFn(ev)
      if (this.$refs.audioEl.paused) {
        this.playBtn()
      }
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      } else {
        return `${minutes}:${secs.toString().padStart(2, '0')}`;
      }
    },
    setVolume(event) {
      const volume = event.target.value
      if (this.$refs.audioEl.volume !== volume) {
        this.$refs.audioEl.volume = volume;
      }
    }
  },
  mounted() {
    // 添加错误处理
    if (this.$refs.audioEl) {
      this.$refs.audioEl.addEventListener('error', (e) => {
        console.warn('音频加载失败:', e);
        this.altogetherTimer = 0;
      });
    }
  },
  watch: {
    source(newVal) {
      // 当音频源变化时，重置状态
      if (newVal) {
        this.isPlaying = false;
        this.currentTime = 0;
        this.accomplishData = 0;
        // 清除定时器
        clearInterval(timer);
        // 下一次DOM更新后重新初始化
        this.$nextTick(() => {
          if (this.$refs.audioEl) {
            this.$refs.audioEl.load();
          }
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.mainpart {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0;
  cursor:pointer;
}

.mainpart .operationBox {
  width: 100%;
  height: 50px;
  padding: 6px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .3);
  background-color: #e7edf1;
  border-radius: 25px;
}

/* 进度条 */
.operationBox .audioTrack {
  flex: 1;
  height: 6px;
  margin: 0 auto;
  position: relative;
  background-color: rgba(255, 255, 255, .75);
  border-radius: 2px;
}

.audioPercentage {
  width: 0;
  height: 6px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--primary-color);
  opacity: .85;
  transition: all .05s;
  border-radius: 2px;
}

.audioPercentage::after {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 5px 3px #93bae6;
  right: -10px;
  top: -1px;
  cursor: pointer;
}

.player-currentTime {
  position: absolute;
  top: 10px;
  left: 0;
  opacity: .85;
  transition: all .05s;
  font-size: 12px;
}

.player-totalTime {
  position: absolute;
  top: 10px;
  right: 0;
  opacity: .85;
  transition: all .05s;
  font-size: 12px;
}


.operationBox{
  /* 播放/暂停按钮 */
  .playButtCon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    background-color: var(--primary-color);
    margin-right: 20px;
    cursor: pointer;
  }
  .sound-speed {
    width: 40px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: var(--primary-color);
    cursor: pointer;
    position: relative;
    margin-left: 10px;
  }

  .sound-right {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: var(--primary-color);
    cursor: pointer;
    position: relative;
    &:hover .sound-range {
      display: block!important;
    }
  }
}

.speed-menu {
  width: 80px;
  text-align: center;
}
.sound-range {
  display: none!important;
  transform: rotate(-90deg);
  position: absolute;
  bottom: 50px;
  width: 60px!important;
  filter: drop-shadow(0px 0px 8px #8abbe6);
}


.originalAudio {
  width: 0;
  height: 0;
}

.originalAudio audio {
  width: 0;
  height: 0;
}
</style>
